<div class="main" *ngIf="displayName">
    <div class="sidebar">
        <app-sidebar  [navigationUrl] ="navigationUrl" [displayName] ="displayName" [iRole] ="iRole" [partner] ="partner" [fleets] = "fleets"></app-sidebar>
    </div>
    <div class="container DataBodyContaner">
        <router-outlet></router-outlet>
    </div>
</div>




